import Tween from "tween.ts";
import Animation from "./Animation";
import WinningElmInfo from "../entities/howtoplay/firstPart/WinningElmInfo";

export default class HTPWElmInfoAnimation extends Animation {
  constructor(InfoCon: WinningElmInfo, scale, onComp: () => void) {
    super();
    new Tween.Tween(InfoCon.scale)
      .to({ x: scale, y: scale }, 1000)
      .easing(Tween.Easing.Bounce.Out)
      .onComplete(() => { onComp() })
      .start()
  }
}